import { Loader } from "../Common";
export default function Home (params) {
  return(
    <Loader open={true} />
  )
}